/**
 * This file is auto-generated from StripePaymentForm.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const paymentFailed: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Payment failed. Please try again.';
        case 'pl':
            return 'Płatność nie powiodła się. Spróbuj ponownie.';
    }
};
